import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import PeriodicityServices from "./Periodicity.services";
import moment from "moment";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetPeriodicity = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PERIODICITYS,
      payload: true,
    });
    dispatch({
      type: actions.GET_PERIODICITYS_BY_ID,
      payload: [],
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PERIODICITYS,
      payload: false,
    });
  }
};

export const getPeriodicity = (filter) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PERIODICITYS,
      payload: true,
    });
    const resp = await PeriodicityServices.getPeriodicity(filter);
    dispatch({
      type: actions.GET_PERIODICITYS_BY_ID,
      payload: resp.data.data,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PERIODICITYS,
      payload: false,
    });
  }
};

export const resetPeriodicityByOrg = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PERIODICITY,
      payload: true,
    });
    dispatch({
      type: actions.GET_PERIODICITY_BY_ID,
      payload:{},
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
  } finally {
    dispatch({
      type: actions.LOADING_PERIODICITY,
      payload: false,
    });
  }
};

export const getPeriodicityByOrg = (filter) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PERIODICITY,
      payload: true,
    });
    const resp = await PeriodicityServices.getPeriodicity(filter);
    dispatch({
      type: actions.GET_PERIODICITY_BY_ID,
      payload:
        resp.data.data.length>0
          ? resp.data.data[0]
          : {},
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
  } finally {
    dispatch({
      type: actions.LOADING_PERIODICITY,
      payload: false,
    });
  }
};

export const getPeriodicityByOrgList = (filter,setAnio) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PERIODICITY_LIST,
      payload: true,
    });
    const resp = await PeriodicityServices.getPeriodicity(filter);
    const length = resp.data.count - 1;
    const fecha = new Date();
    const currentYear = fecha.getFullYear();
    if(setAnio){
      if(resp.data.data.length>0){
        setAnio(resp.data.data[length].anio?resp.data.data[length].anio+1:currentYear)
      }else{
        setAnio(currentYear)
      }
    }
    dispatch({
      type: actions.GET_PERIODICITY_LIST_BY_ID,
      payload: resp.data.data,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
  } finally {
    dispatch({
      type: actions.LOADING_PERIODICITY_LIST,
      payload: false,
    });
  }
};

export const getPeriodicityById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PERIODICITY_BY_ID,
      payload: true,
    });
    const resp = await PeriodicityServices.getPeriodicityById(id);
    dispatch({
      type: actions.GET_PERIODICITY_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PERIODICITY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PERIODICITY_BY_ID,
      payload: false,
    });
  }
};

export const savePeriodicity = (data, setIsSubmit, setAnio) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PERIODICITY,
        payload: true,
      });
      const resp = await PeriodicityServices.savePeriodicity(data);
      const _resp = resp.data;
      dispatch({
        type: actions.GET_PERIODICITY_BY_ID,
        payload: _resp,
      });
      setIsSubmit(true);
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      dispatch({
        type: actions.PERIODICITY_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      dispatch(
        getPeriodicityByOrgList({
          tipo_busqueda: "empresa__id",
          filter: data.empresa,
          tipo_busqueda_2:"clasificacion_id",
          filter_2: parseInt(_resp.clasificacion),
        },setAnio)
      );
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.errorMessage + " " + ex.response.statusText;
              }
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
      dispatch({
        type: actions.PERIODICITY_FAIL,
        payload: "",
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PERIODICITY,
        payload: false,
      });
    }
  };

export const editPeriodicity = (data, id, setIsSubmit) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PERIODICITY,
        payload: true,
      });
      const resp = await PeriodicityServices.editPeriodicity(id, data);
      dispatch({
        type: actions.GET_PERIODICITY_BY_ID,
        payload: resp.data,
      });
      setIsSubmit(true);
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PERIODICITY,
        payload: false,
      });
    }
  };

export const deletePeriodicity = (id, setErrorPeriod, setFormError) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PERIODICITY,
        payload: true,
      });
      await PeriodicityServices.deletePeriodicity(id);
      setErrorPeriod("");
      setFormError("");
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      setErrorPeriod(message);
      setFormError("");
    } finally {
      dispatch({
        type: actions.LOADING_PERIODICITY,
        payload: false,
      });
    }
  };
